import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewsDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { IsNewsLikedByMePipe } from "src/app/pipes/is-news-liked-by-me/is-news-liked-by-me.pipe";
import { RootState } from "src/app/store";
import * as NewsActions from "src/app/store/news/actions";
import * as FromNews from "src/app/store/news/selectors";
import { first } from "rxjs/operators";
import { NEWS_PER_PAGE } from "src/app/constants";
import { IonRouterOutlet, InfiniteScrollCustomEvent } from "@ionic/angular";
import { NavigationService } from "src/app/services/navigation/navigation.service";

@Component({
  selector: "app-news-feed",
  templateUrl: "./news-feed.component.html",
  styleUrls: ["./news-feed.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsFeedComponent {
  public loading$: Observable<boolean> = this.store.select(FromNews.selectLoading);
  public news$: Observable<NewsDto[]> = this.store.select(FromNews.selectAll);
  public currentPage$: Observable<number> = this.store.select(FromNews.selectCurrentPage);
  public totalPages$: Observable<number> = this.store.select(FromNews.selectTotalPages);

  constructor(
    private store: Store<RootState>,
    private isNewsLikeByMe: IsNewsLikedByMePipe,
    private navigationService: NavigationService,
    private routerOutlet: IonRouterOutlet,
  ) {}

  public async toggleNewsLike(event: Event, news: NewsDto): Promise<void> {
    event.stopPropagation();
    this.isNewsLikeByMe
      .transform(news)
      .pipe(first())
      .subscribe(isNewsLikedByMe =>
        isNewsLikedByMe
          ? this.store.dispatch(NewsActions.unlikeNews({ newsId: news.id }))
          : this.store.dispatch(NewsActions.likeNews({ newsId: news.id })),
      );
  }

  public loadMoreNews(event: InfiniteScrollCustomEvent): void {
    this.currentPage$
      .pipe(first())
      .subscribe(currentPage => this.store.dispatch(NewsActions.getNews({ limit: NEWS_PER_PAGE, page: currentPage + 1, event })));
  }

  public async handleClick(news: NewsDto): Promise<void> {
    this.navigationService.handleNavigationTo(news.actionLink, this.routerOutlet.nativeEl);
  }
}
